export default function CompanyInfo() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">
          会社概要
        </h2>

        <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
          <div className="divide-y divide-gray-200">
            <div className="grid md:grid-cols-3 gap-4 p-6 hover:bg-gray-50 transition-colors">
              <div className="font-bold text-gray-700">会社名</div>
              <div className="md:col-span-2 text-gray-900">株式会社 ON TRUST</div>
            </div>

            <div className="grid md:grid-cols-3 gap-4 p-6 hover:bg-gray-50 transition-colors">
              <div className="font-bold text-gray-700">代表者</div>
              <div className="md:col-span-2 text-gray-900">西川 航志</div>
            </div>

            <div className="grid md:grid-cols-3 gap-4 p-6 hover:bg-gray-50 transition-colors">
              <div className="font-bold text-gray-700">設 立</div>
              <div className="md:col-span-2 text-gray-900">2023年5月9日</div>
            </div>

            <div className="grid md:grid-cols-3 gap-4 p-6 hover:bg-gray-50 transition-colors">
              <div className="font-bold text-gray-700">資本金</div>
              <div className="md:col-span-2 text-gray-900">3450万円</div>
            </div>

            <div className="grid md:grid-cols-3 gap-4 p-6 hover:bg-gray-50 transition-colors">
              <div className="font-bold text-gray-700">所在地</div>
              <div className="md:col-span-2 text-gray-900">
                〒102-0082<br />
                東京都千代田区一番町9番地グランドメゾン一番町503
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-4 p-6 hover:bg-gray-50 transition-colors">
              <div className="font-bold text-gray-700">事業内容</div>
              <div className="md:col-span-2 text-gray-900">
                財務コンサルティング
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-4 p-6 hover:bg-gray-50 transition-colors">
              <div className="font-bold text-gray-700">Mail</div>
              <div className="md:col-span-2">
                <a 
                  href="mailto:info@on-trust.co.jp"
                  className="text-amber-600 hover:text-amber-700 transition-colors cursor-pointer"
                >
                  info@on-trust.co.jp
                </a>
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-4 p-6 hover:bg-gray-50 transition-colors">
              <div className="font-bold text-gray-700">貸金業登録番号</div>
              <div className="md:col-span-2 text-gray-900">東京都知事（1）第 31988号</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
